import { createContext, useContext } from 'react';

import { InteractionFormDensity } from './interactionFormTokens';

/**
 * Density is set once by `InteractionFormShell` and read by the field blocks
 * beneath it, so per-field renderers don't have to thread a `density` prop
 * through every switch case.
 *
 * Every current surface wraps its forms in a shell, so in practice the density
 * always arrives from that provider. The Compact default is the safety net for a
 * field block rendered without one — it gets the desktop rhythm rather than
 * `undefined` — not a supported pattern to build on.
 */
export const InteractionFormDensityContext = createContext<InteractionFormDensity>(
  InteractionFormDensity.Compact
);

export const useInteractionFormDensity = (): InteractionFormDensity =>
  useContext(InteractionFormDensityContext);
